import { render } from "./HouseRents.vue?vue&type=template&id=72e4f004&scoped=true"
import script from "./HouseRents.vue?vue&type=script&lang=js"
export * from "./HouseRents.vue?vue&type=script&lang=js"

import "./HouseRents.vue?vue&type=style&index=0&id=72e4f004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e4f004"]])

export default __exports__